import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ampli } from '../../../../ampli';
import { patchUserSellTractors } from '../../../../api/user/mutations/patchUserSellTractors';

export const usePatchUserSellTractorsMutation = () => {
  const location = useLocation();
  const queryClient = useQueryClient();

  return useMutation(patchUserSellTractors, {
    onError: (error: Error) =>
      ampli.에러발생({
        '에러 내용': error.toString(),
        '에러 종류': '판매 트랙터 수정 실패',
        '에러가 발생한 URL': location.pathname,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user_sell_tractors/mine'],
      });
    },
  });
};
